export default {"src":"/_next/static/image/public/images/ic_grey_modal_close.b0ff474e005fd94f09408d338225cf7c.svg","height":17,"width":17};